import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SonaIconComponent } from '@sona/angular-ui-components';
import { HlmButtonDirective } from '@spartan-ng/ui-button-helm';
import { Table } from '@tanstack/angular-table';

@Component({
    selector: 'sona-paginator',
    imports: [ HlmButtonDirective, SonaIconComponent, TranslatePipe ],
    template: `
        <button
                hlmBtn
                variant="outline"
                size="icon-sm"
                class="tw-bg-background"
                [disabled]="table().getState().pagination.pageIndex === 0"
                [attr.aria-label]="'REPORTS.COMPONENT.PAGINATOR.FIRST_PAGE' | translate"
                (click)="table().firstPage()"
        >
            <sona-icon name="caret-line-left" size="small" appearance="bold" />
        </button>
        <button
                hlmBtn
                variant="outline"
                size="icon-sm"
                class="tw-bg-background"
                [disabled]="!table().getCanPreviousPage()"
                [attr.aria-label]="'REPORTS.COMPONENT.PAGINATOR.PREVIOUS_PAGE' | translate"
                (click)="table().previousPage()"
        >
            <sona-icon name="caret-left" size="small" appearance="bold" />
        </button>
        <button
                hlmBtn
                variant="outline"
                size="icon-sm"
                class="tw-bg-background"
                [disabled]="!table().getCanNextPage()"
                [attr.aria-label]="'REPORTS.COMPONENT.PAGINATOR.NEXT_PAGE' | translate"
                (click)="table().nextPage()"
        >
            <sona-icon name="caret-right" size="small" appearance="bold" />
        </button>
        <button
                hlmBtn
                variant="outline"
                size="icon-sm"
                class="tw-bg-background"
                [disabled]="table().getState().pagination.pageIndex === table().getPageCount() - 1"
                [attr.aria-label]="'REPORTS.COMPONENT.PAGINATOR.LAST_PAGE' | translate"
                (click)="table().lastPage()"
        >
            <sona-icon name="caret-line-right" size="small" appearance="bold" />
        </button>
    `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'tw-flex tw-gap-2'
    }
})
export class SonaPaginatorComponent<T> {

    readonly table = input.required<Table<T>>();
}
